import script from "./UsersView.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersView.vue?vue&type=script&setup=true&lang=js"

import "./UsersView.vue?vue&type=style&index=0&id=72e08d9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e08d9f"]])

export default __exports__